export default __webpack_public_path__ + "static/media/icon_ticket.3932abf3.svg";